/* eslint-disable no-plusplus */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react";

import { init } from "echarts";
import Color from "@/tool/color";
import moPortrait from "../../../store/portrait";
import Empty from "@/component/empty";
import { isEmpty } from "lodash";
import moIndex from "@/page/index/store";

interface IProps {}
interface IState {}
let echartdom: any = null;

const TopRanking = (props: IProps, state: IState) => {
  const { hotProfessionaList } = moPortrait;
  const { isMock } = moIndex;
  const topRef = useRef<any>(null);

  const lengend = useMemo(() => {
    const list: any = [];
    hotProfessionaList?.forEach((ele: any) => {
      list.unshift(ele.major);
    });
    return list;
  }, [hotProfessionaList]);
  const render = () => {
    if (echartdom) echartdom.dispose();
    echartdom = init(topRef.current);
    const option = {
      legend: {
        data: [],
      },
      grid: {
        left: "3%",
        right: "3%",
        bottom: "3%",
        top: 20,
        containLabel: true,
      },
      xAxis: [
        {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.1),
              width: 1,
              type: "dashed",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisLabel: {
            show: false,
            interval: "auto",
            color: Color.blackColor(0.5),
            fontFamily: "PingFang SC",
          },
        },
      ],
      yAxis: [
        {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            interval: "auto",
            color: Color.blackColor(0.85),
            margin: 50,
            formatter(val: any) {
              const strs = val.split(""); // 字符串数组
              let str = "";
              for (let i = 0, s; (s = strs[i++]); ) {
                // 遍历字符串数组
                str += s;
                if (!(i % 12)) str += "\n"; // 按需要求余
              }
              return str;
            },
            fontFamily: "PingFang SC",
          },
          data: lengend,
        },
      ],
      series: [
        {
          name: "人数",
          type: "bar",
          label: {
            show: false,
            position: "right",
          },
          emphasis: {
            label: {
              show: false,
              position: "right",
            },
            focus: "self",
            blurScope: "coordinateSystem",
          },
          color: Color.primary,
          lineStyle: {
            color: Color.primary,
            width: 2,
          },
          itemStyle: {
            borderRadius: [0, 5, 5, 0],
          },
          barWidth: 16,
          data: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        },
      ],
    };
    echartdom.setOption(option);
  };
  useEffect(() => {
    if (!isEmpty(hotProfessionaList)) {
      render();
    }
    window.addEventListener("resize", render);
    return () => {
      window.removeEventListener("resize", render);
    };
  }, [hotProfessionaList]);

  return (
    <section
      className="top-rank10-warp"
      style={{
        backgroundImage: isMock
          ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
          : "",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
      }}
    >
      <p className="rank10-title">热门专业 TOP 10</p>
      {!isEmpty(hotProfessionaList) ? (
        <section ref={topRef} className="top-rank-svg" />
      ) : (
        <Empty />
      )}
    </section>
  );
};

export default observer(TopRanking);
